// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unvergessen-list[data-v-3c7e147e]{padding-top:0;padding-bottom:0}.unvergessen-list-item[data-v-3c7e147e]{background-color:var(--v-secondary-base)}.unvergessen-list-item-content[data-v-3c7e147e]{padding:0}.unvergessen-hover[data-v-3c7e147e]{background-color:var(--v-secondary-hover-base)}", ""]);
// Exports
module.exports = exports;
